import React from "react";
import api from "../../utils/api";
import { Button } from "../../common/Button/Button";
import Select from "react-select";
import { useState } from "react";
import Spinner from "../../common/Spinner/Spinner";
import { ControlledInput } from "../../common/Input/Input";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { getServiceTypesMaster } from "../../utils/localStorage";
import find from "lodash/find";
import { ArrowLeft} from "react-feather";
import { useEffect } from "react";

export default function MapPackageServices(props)
{

    const getServiceName = (code) => 
    {
		if (!code) return;
		const found = find(getServiceTypesMaster(), { sServiceCode: code });
		if (found) {
			return found.sServiceName;
		}
		return "";
    };

    const [speakerData, setSpeakerData] = useState()
    const [selectedSpeakerDataOption, setSelectedSpeakerDataOption] = useState('')

    const handleSpeakerList = () => {
        let payload = {
            // api_key: '82mqEyJnct4kzC8y'
            api_key: "r54B?rHXUE7v%$9t"
        }
        api.getSpeakerList(payload).then(({ data }) => {
            setSpeakerData(data.data)
        })
    }
    console.log("New==", speakerData)
    useEffect(() => {
        handleSpeakerList()

    }, [])
    
    let SpeakerList

        if (speakerData) {
             SpeakerList = speakerData.map((ele) => {
                return {
                    value: ele["name"],
                    val: ele['company_name'],
                  label: ele["name"] + (ele["company_name"] ? "(" + ele["company_name"] + ")" : "")
                };
            });
            console.log(SpeakerList)
            }
    

    const getServiceCode = (id) => {
		if (!id) return;
		const found = find(props.serviceCatalogueList, { sCatalogueId: id });
		if (found) {
			return found.sServiceCode;
		}
		return "";
	};

    const packageColumns = [
		{
			id: "refCatalogue",
			Header: "Service Catalogue",
            accessor: "refCatalogue",
            Cell: ({ original }) =>getServiceName(getServiceCode(original.refCatalogue)),
		},
		{
			id: "refExternalServicePartner",
			Header: "External Service Partner",
			accessor: "refExternalServicePartner",
        },
        {
			id: "fPackageOfferAmount",
			Header: "Package Amount",
			accessor: "fPackageOfferAmount",
		},
        {
			id: "fdeAsraPlatformCharges",
			Header: "Platform Charges",
			accessor: "fdeAsraPlatformCharges",
        },
        {
			id: "fPackageOfferGST",
			Header: "GST Amount",
			accessor: "fPackageOfferGST",
        },
        {
			id: "refCatalogue",
			Header: "Action",
			accessor: "refCatalogue",
			Cell: ({ original }) =>
			(
                <>
                {props.selectedPackageCatalogue.bIsActive?props.selectedPackageCatalogue.sPackageOfferStatus==="Draft"?
                    (
                        <>
                            <Button style={{marginRight:"10px"}} onClick={(f) =>props.onEditMappedserviceClicked(original)}>
                                Edit
                            </Button>
                            <Button onClick={(f) =>props.onDeleteMappedserviceClicked(original)}>
                                Delete
                            </Button>
                        </>
                    ):
                    (
                        <>
                            <Button style={{marginRight:"10px"}} className="disabled">
                                    Edit
                            </Button>
                            <Button className="disabled">
                                Delete
                            </Button>
                        </>
                    ):
                    (
                        <>
                            <Button style={{marginRight:"10px"}} className="disabled">
                                    Edit
                            </Button>
                            <Button className="disabled">
                                Delete
                            </Button>
                        </>
                    )
                }
                </>
            ),
            //width:100,
		},
    ];

    const columns = [
		{
			id: "sResourceType",
			Header: "Resource Type",
            accessor: "sResourceType",
            //Cell: ({ original }) =>getServiceName(getServiceCode(original.refCatalogue)),
            width:120
		},
		{
			id: "sResourceName",
			Header: "Resource Name",
			accessor: "sResourceName",
            width:200,
           /* Cell:({original})=>(
                <>
                    {original.sResourceType==="Service"?
                    (
                        getServiceName(getServiceCode(original.sResourceName))
                    ):
                    (
                        original.sResourceName
                    )}
                </>
            ),*/
            
        },
        {
			id: "refExternalServicePartner",
			Header: "External Service Partner",
			accessor: "refExternalServicePartner",
            width:150
        },
        {
			id: "sOfferDeliveryType",
			Header: "Offer Delivery Type",
			accessor: "sOfferDeliveryType",
            width:200
        },
        {
			id: "nNumberOfDays",
			Header: "Number Of Days",
			accessor: "nNumberOfDays",
            width:100,
		},
        {
			id: "fPackageOfferAmount",
			Header: "Offer Amount",
			accessor: "fPackageOfferAmount",
            width:120
		},
        {
			id: "fdeAsraPlatformCharges",
			Header: "Platform Charges",
			accessor: "fdeAsraPlatformCharges",
            width:120
        },
        {
			id: "fPackageOfferGST",
			Header: "GST Amount",
			accessor: "fPackageOfferGST",
            width:100
        },
        {
			id: "refCatalogue",
			Header: "Action",
			accessor: "refCatalogue",
            width:180,
			Cell: ({ original }) =>
			(
                <>
                {props.selectedPackageCatalogue.bIsActive?props.selectedPackageCatalogue.sPackageOfferStatus==="Draft"?
                    (
                        <>
                            <Button style={{marginRight:"10px"}} onClick={(f) =>props.onEditMappedserviceClicked(original)}>
                                Edit
                            </Button>
                            <Button onClick={(f) =>props.onDeleteMappedserviceClicked(original)}>
                                Delete
                            </Button>
                        </>
                    ):
                    (
                        <>
                            <Button style={{marginRight:"10px"}} className="disabled">
                                    Edit
                            </Button>
                            <Button className="disabled">
                                Delete
                            </Button>
                        </>
                    ):
                    (
                        <>
                            <Button style={{marginRight:"10px"}} className="disabled">
                                    Edit
                            </Button>
                            <Button className="disabled">
                                Delete
                            </Button>
                        </>
                    )
                }
                </>
            ),
            //width:100,
		},
    ];

    return (
    <div className={`row row-container ${props.isLoading && "set-opacity"}`}>
        {props.isLoading && <Spinner className="center-screen" />}
        <div className="col-12 row-margin-10px">
            <span style={{cursor:"pointer"}} onClick={props.onCancelPackageServiceMapping}>
            <ArrowLeft style={{marginRight:"10px"}}/>
            </span>
            <label>
                <b>
                {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                ("Map Offering Resources for "):("Map Package Services for ")}
                    {props.selectedPackageCatalogue.sPackageOfferTitle}
                </b>
            </label><br/>
        </div>
        <div className="col-12">
            <div className='form-group'>
                <div className="row">
                    {
                        props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                        (
                            <div className="col-3 form-group">
                            <label style={{marginBottom:"10px"}}>Resource Subtype <span className="required">*</span></label><br/>
                            <Select
                                placeholder={"Select resource type"}
                                isDisabled={props.viewIsForEditing}
                                options={props.ResourceTypeOptions}
                                onChange={props.onResourceTypeOptionChange}
                                value={props.selectedResourceTypeOption}
                            
                            />
                        </div>  
                        ):
                        ("")
                    }

                    {
                        props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                        (
                            <div className="col-3 form-group">
                                <label style={{marginBottom:"10px"}}>
                                    Resource Name
                                    <span className="required">*</span></label><br/>
                                <Select
                                    options={props.ResourceNameListOptions}
                                    onChange={props.onResourceNameListOptionChange}
                                    value={props.selectedResourceNameListOption}
                                    placeholder={"Select resource name"}
                                    isDisabled={props.viewIsForEditing}
                                />
                            </div>
                        ):
                        (
                            <div className="col-3 form-group">
                                <label style={{marginBottom:"10px"}}>
                                    Service Catalogue
                                    <span className="required">*</span></label><br/>
                                <Select
                                    options={props.ResourceNameListOptions}
                                    onChange={props.onResourceNameListOptionChange}
                                    value={props.selectedResourceNameListOption}
                                    placeholder={"Select service catalogue"}
                                    isDisabled={props.viewIsForEditing}
                                />
                            </div>
                        )
                        }  
                        
                        {
                            props.selectedResourceNameListOption != null && (props.selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner" || props.selectedResourceNameListOption.value === "GRPEXPRTCONSULT")
                                ?
                                (
                                    <div className="col-3 form-group">
                                    <label style={{marginBottom:"10px"}}>
                                        Speaker Name 
                                        <span className="required">*</span></label><br/>
                                    <Select
                                        options={SpeakerList}
                                            onChange={props.onSpeakerListOptionsChange}
                                        value={props.selectedSpeakerDataOption}
                                        placeholder={"Select Speaker"}
                                    />
                                </div>
                            )    
                            : ""
                        }

                        {/* {
                            props.selectedResourceTypeOption.value && props.selectedResourceTypeOption.value === "Service" ?
                            
                                props.selectedResourceNameListOption != null && props.selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner"
                                    ?
                                    (
                                        <div className="col-3 form-group">
                                        <label style={{marginBottom:"10px"}}>
                                            Speaker Name 
                                            <span className="required">*</span></label><br/>
                                        <Select
                                            options={SpeakerList}
                                                onChange={(option) => {
                                                setSelectedSpeakerDataOption(option)
                                            }}
                                            value={props.selectedSpeakerDataOption}
                                            placeholder={"Select Speaker"}
                                        />
                                    </div>
                                )    
                                : ""
                            
                                    :
                                    
                                        props.selectedResourceNameListOption != null && props.selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner"
                                            ?
                                            (
                                                <div className="col-3 form-group">
                                                <label style={{marginBottom:"10px"}}>
                                                    Speaker Name 
                                                    <span className="required">*</span></label><br/>
                                                <Select
                                                    options={SpeakerList}
                                                        onChange={(option) => {
                                                        setSelectedSpeakerDataOption(option)
                                                    }}
                                                    value={props.selectedSpeakerDataOption}
                                                    placeholder={"Select Speaker"}
                                                />
                                            </div>
                                        )    
                                        : ""
                                    
                        } */}

                    {
                        props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                        (
                            <>
                                {
                                    props.selectedResourceTypeOption.value && props.selectedResourceTypeOption.value==="Service"?
                                    (
                                        <div className="col-3">
                                        <label style={{marginBottom:"10px"}}>External Service Partner </label><br/>
                                        <Select
                                            options={props.externalServicePartnerOptions}
                                            onChange={props.onExternalServicePartnerChange}
                                            value={props.selectedExternalServicePartner}
                                            isClearable
                                            placeholder={"Select external service partner"}
                                        />
                                        </div>
                                    )
                                    :
                                    ("")
                                }
                            </>
                        ):
                        (
                            <div className="col-3">
                                <label style={{marginBottom:"10px"}}>External Service Partner</label><br/>
                                <Select
                                    options={props.externalServicePartnerOptions}
                                    onChange={props.onExternalServicePartnerChange}
                                    value={props.selectedExternalServicePartner}
                                    isClearable
                                    placeholder={"Select external service partner"}
                                />
                            </div>
                        )
                    }
                    {
                        props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                        (
                            <>
                                <div className="col-3">
                                <label style={{marginBottom:"10px"}}>Offer Delivery Type <span className="required">*</span></label><br/>
                                <Select
                                    options={props.OfferDeliveryTypeOptions}
                                    onChange={props.onOfferDeliveryTypeOptionChange}
                                    value={props.selectedOfferDeliveryTypeOption}
                                    placeholder={"Select offer delivery type"}
                                />
                                </div>
                                {
                                    props.selectedOfferDeliveryTypeOption.value==="On Start Date of Offering + No of Days"||props.selectedOfferDeliveryTypeOption.value==="On End Date of Offering + No of Days"?
                                    (
                                        <div className="col-3">
                                            <label style={{marginBottom:"10px"}}>Number of days <span className="required">*</span></label><br/>
                                                <ControlledInput
                                                    name="nNumberOfDays"
                                                    placeholder="Number of days"
                                                    value={props.packageServiceMappingData.nNumberOfDays || ""}
                                                    onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                                    autoComplete="off"
                                                />
                                        </div>
                                    ):("")
                                }
                                
                            </>
                        ):
                        ("")
                    }                    
                    
                    <div className="col-3">
                    <label style={{marginBottom:"10px"}}>Original Amount (Incl. GST)<span className="required"></span></label><br/>
                        <ControlledInput
                            name="fAmountFull"
                            placeholder="Original Amount"
                            value={props.selectedServiceCatalogue&&props.selectedServiceCatalogue.fAmountFull || ""}
                            className="disabled"
                            readOnly
                            autoComplete="off"
                            
                        />
                    </div>
                    {props.selectedPackageCatalogue.sPackageOfferPaymentType==="Free" || props.selectedPackageCatalogue.sPackageOfferPaymentType==="Dynamic"?
                    (
                        <div className="col-3">
                            <label style={{marginBottom:"10px"}}>Package/Offering Amount (Incl. GST)</label><br/>
                                <ControlledInput
                                    name="fPackageOfferAmount"
                                    placeholder="Package/Offering Amount"
                                    value={props.packageServiceMappingData.fPackageOfferAmount || ""}
                                    onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                    autoComplete="off"
                                    readOnly
                                />
                        </div>
                    ):
                    (
                        <div className="col-3">
                            <label style={{marginBottom:"10px"}}>Package/Offering Amount (Incl. GST)</label><br/>
                                <ControlledInput
                                    name="fPackageOfferAmount"
                                    placeholder="Package/Offering Amount"
                                    value={props.packageServiceMappingData.fPackageOfferAmount || ""}
                                    onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                    autoComplete="off"
                                />
                        </div>
                    )}
                    
                    <div className="col-3">
                    <label style={{marginBottom:"10px"}}>Platform Charge Type <span className="required">*</span></label><br/>
                    <Select
						options={props.platformChargesOptions}
						onChange={props.onPlatformChargesOptionChange}
                        value={props.selectedPlatformChargesOption}
                        placeholder={"Platform Charge Type"}
                        isDisabled={props.selectedPackageCatalogue.sPackageOfferPaymentType==="Free" || props.selectedPackageCatalogue.sPackageOfferPaymentType==="Dynamic"?true:false}
					/>
                    </div>
                    {
                        props.selectedPlatformChargesOption.value==="Percentage"?
                        (
                            <>
                                <div className="col-3">
                                    <label style={{marginBottom:"10px"}}>Platform Charge Percentage <span className="required">*</span></label><br/>
                                        <ControlledInput
                                            name="fPlatformChargePercentage"
                                            placeholder="Platform Charge Percentage"
                                            value={props.packageServiceMappingData.fPlatformChargePercentage || ""}
                                            onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                            autoComplete="off"
                                        />
                                </div>
                                <div className="col-3">
                                    <label style={{marginBottom:"10px"}}>Platform Charges <span className="required">*</span></label><br/>
                                        <ControlledInput
                                            name="fdeAsraPlatformCharges"
                                            placeholder="Platform Charges"
                                            value={props.packageServiceMappingData.fdeAsraPlatformCharges || ""}
                                            onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                            autoComplete="off"
                                            readOnly
                                        />
                                </div>
                            </>
                        ):
                        (
                            <>
                                {props.selectedPackageCatalogue.sPackageOfferPaymentType==="Free" || props.selectedPackageCatalogue.sPackageOfferPaymentType==="Dynamic"?
                                (
                                    <div className="col-3">
                                        <label style={{marginBottom:"10px"}}>Platform Charges </label><br/>
                                        <ControlledInput
                                            name="fdeAsraPlatformCharges"
                                            placeholder="Platform Charges"
                                            value={props.packageServiceMappingData.fdeAsraPlatformCharges || ""}
                                            onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                            autoComplete="off"
                                            readOnly
                                        />
                                    </div>
                                ):
                                (
                                    <div className="col-3">
                                        <label style={{marginBottom:"10px"}}>Platform Charges</label><br/>
                                        <ControlledInput
                                            name="fdeAsraPlatformCharges"
                                            placeholder="Platform Charges"
                                            value={props.packageServiceMappingData.fdeAsraPlatformCharges || ""}
                                            onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                )}
                            </>
                            
                        )
                    }
                    <div className="col-3">
                    <label style={{marginBottom:"10px"}}>GST Percenatge <span className="required">*</span></label><br/>
                    <Select
						options={props.GSTPercentageOptions}
						onChange={props.onGSTPercentageOptionChange}
                        value={props.selectedGSTPercentageOption}
                        placeholder={"Select GST Percenatge"}
                        isDisabled={props.selectedPackageCatalogue.sPackageOfferPaymentType==="Free" || props.selectedPackageCatalogue.sPackageOfferPaymentType==="Dynamic"?true:false}
					/>
                    </div>
                    
                    <div className="col-3">
                    <label style={{marginBottom:"10px"}}>GST Amount<span className="required">*</span></label><br/>
                        <ControlledInput
                            name="fPackageOfferGST"
                            placeholder="GST Amount"
                            value={props.packageServiceMappingData.fPackageOfferGST || ""}
                            onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                            autoComplete="off"
                            readOnly
                        />
                    </div>                   
                   
                    <div className="col-3">
                    <label style={{marginBottom:"10px"}}><span className="required">{" "} </span></label>
                        {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                        (
                            <>
                            {props.selectedResourceTypeOption.value && props.selectedResourceTypeOption.value==="Service"&&
                            props.selectedPlatformChargesOption.value==="Percentage"?(""):(<br/>)}</>
                        ):
                        (
                            <>{props.selectedPlatformChargesOption.value==="Percentage"?(<br/>):("")}</>
                        )}
                    
                        <div className="float-left disabled" style={{marginRight:"10px",marginTop:"10px"}}>
                            {
                                props.viewIsForEditing?
                                (
                                    <Button onClick={props.onUpdatePackageService}>
                                        {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Update Resource"):("Update Service")}
                                    </Button>
                                ):
                                (
                                    <>
                                        {props.selectedPackageCatalogue.bIsActive?props.selectedPackageCatalogue.sPackageOfferStatus==="Draft"?
                                            (
                                                <Button
                                                    onClick={props.onAddPackageService}>
                                                    {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Add Resource"):("Add Service")}
                                                </Button>
                                            ):
                                            (
                                                <Button className="disabled">
                                                        {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Add Resource"):("Add Service")}
                                                </Button>
                                            ):
                                            (
                                                <Button className="disabled">
                                                        {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Add Resource"):("Add Service")}
                                                </Button>
                                            )
                                        }
                                    </>
                                )
                            }
							
						</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 row-margin-10px">
            <label>
            {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                (<b>Offering Resources</b>):(<b>Package Services</b>)}                
            </label>
            <div className="float-right">
                <div className="float-left" style={{marginRight:"10px"}}>
                    {props.selectedPackageCatalogue.bIsActive?props.selectedPackageCatalogue.sPackageOfferStatus==="Draft"?
                        (
                            <Button onClick={props.onSubmitPackageServiceMapping}>
                                 {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Map Offering Resources"):("Map Package Services")}
                            </Button>
                        ):
                        (
                            <Button className="disabled">
                                {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Map Offering Resources"):("Map Package Services")}
                            </Button>
                        ):
                        (
                            <Button className="disabled">
                                {props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?
                                ("Map Offering Resources"):("Map Package Services")}
                            </Button>
                        )
                    }
                    
                </div>
                <div className="float-left">
                    <Button onClick={props.onCancelPackageServiceMapping}>
                    Cancel
                    </Button>
                </div>
            </div>
        </div>
        <div className="col-12">
            <ReactTable
                data={props.packageMappedServiceList || []}
                columns={props.selectedPackageCatalogue.sType!=''&&props.selectedPackageCatalogue.sType!="Package"?columns:packageColumns}
                manual
                sortable={false}
                showPagination={false}
                style={{overflowY: "auto",height: "350px"}}
                NextComponent={(instance) => (
                    <Button className="mt3" {...instance}>
                        Next
                    </Button>
                )}
                PreviousComponent={(instance) => (
                    <Button className="mt3" {...instance}>
                        Previous
                    </Button>
                )}
            />
        </div>
    </div>
    );
}